export class CashUpReportUpdateDto {
  id: number;
  note?: string;
  closedDayTime?: string;
}
